"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var metrics_exports = {};
__export(metrics_exports, {
  EMPTY_PARAMS: () => EMPTY_PARAMS,
  childMetrics: () => childMetrics,
  globals: () => globals,
  measure: () => measure,
  metricsAggregate: () => metricsAggregate,
  metricsToJson: () => metricsToJson,
  metricsToRows: () => metricsToRows,
  metricsToString: () => metricsToString,
  newMetrics: () => newMetrics,
  updateMeasure: () => updateMeasure,
  updateNamedParams: () => updateNamedParams
});
module.exports = __toCommonJS(metrics_exports);
var import_context_utils = require("./context-utils");
const globals = newMetrics();
function newMetrics() {
  return {
    operations: 0,
    value: 0,
    measurements: {},
    params: {},
    namedParams: {}
  };
}
__name(newMetrics, "newMetrics");
const EMPTY_PARAMS = Object.freeze({});
function updateNamedParams(named, params) {
  for (const k of Object.keys(params)) {
    const v = params[k];
    if (!Object.prototype.hasOwnProperty.call(named, k)) {
      setOwnValue(named, k, v);
    } else if (named[k] !== v) {
      named[k] = "*";
    }
  }
}
__name(updateNamedParams, "updateNamedParams");
function ownValue(values, key) {
  return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : void 0;
}
__name(ownValue, "ownValue");
function setOwnValue(values, key, value) {
  if (key === "__proto__") {
    Object.defineProperty(values, key, { value, enumerable: true, writable: true, configurable: true });
  } else {
    values[key] = value;
  }
}
__name(setOwnValue, "setOwnValue");
const parameterIndexes = /* @__PURE__ */ new WeakMap();
function getParameterIndex(results) {
  let index = parameterIndexes.get(results);
  if (index === void 0) {
    index = /* @__PURE__ */ new Map();
    for (const result of results) {
      for (const key of Object.keys(result.params)) {
        if (result.params[key] === true && !index.has(key)) {
          index.set(key, result);
        }
      }
    }
    parameterIndexes.set(results, index);
  }
  return index;
}
__name(getParameterIndex, "getParameterIndex");
function getUpdatedTopResult(current, time, params) {
  if (time === 0) {
    return current;
  }
  const result = current ?? [];
  const newValue = {
    value: time,
    params
  };
  if (result.length > 6) {
    if (result[0].value < newValue.value) {
      result[0] = newValue;
      return result;
    }
    if (result[result.length - 1].value > newValue.value) {
      result[result.length - 1] = newValue;
      return result;
    }
    result[4] = result[5];
    result[3] = result[2];
    result[2] = result[1];
    result[1] = newValue;
    result.length = 5;
    return result;
  } else {
    result.push(newValue);
    return result;
  }
}
__name(getUpdatedTopResult, "getUpdatedTopResult");
function measure(metrics, params, fullParams = EMPTY_PARAMS, endOp) {
  const st = (0, import_context_utils.platformNow)();
  return () => {
    updateMeasure(metrics, st, params, fullParams, endOp);
  };
}
__name(measure, "measure");
function updateMeasure(metrics, st, params, fullParams, endOp, value, override, endedAt = (0, import_context_utils.platformNow)()) {
  const duration = endedAt - st;
  const measuredValue = value ?? duration;
  const fParams = typeof fullParams === "function" ? fullParams() : fullParams;
  const keys = Object.keys(params);
  if (keys.length > 0) {
    const k = keys[0];
    const v = params[k];
    let values = ownValue(metrics.params, k);
    if (values === void 0) {
      values = {};
      setOwnValue(metrics.params, k, values);
    }
    const vKey = `${v?.toString() ?? ""}`;
    if (override === true && value === 0) {
      delete values[vKey];
    } else {
      let param = ownValue(values, vKey);
      if (param === void 0) {
        param = { operations: 0, value: 0 };
        setOwnValue(values, vKey, param);
      }
      if (override === true) {
        param.operations = measuredValue;
      } else {
        param.value += measuredValue;
        param.operations++;
      }
      if (keys.length > 1) {
        const results = param.topResult ??= [];
        const index = getParameterIndex(results);
        for (let i = 1; i < keys.length; i++) {
          const key = `${params[keys[i]]}`;
          const r = index.get(key);
          if (r !== void 0) {
            r.value += 1;
            r.time = (r.time ?? 0) + measuredValue;
          } else {
            const result = { params: { [key]: true }, value: 1, time: measuredValue };
            results.push(result);
            index.set(key, result);
          }
        }
      }
    }
  }
  if (override === true) {
    metrics.operations = measuredValue;
  } else {
    metrics.value += measuredValue;
    metrics.operations++;
  }
  metrics.topResult = getUpdatedTopResult(metrics.topResult, duration, fParams);
  endOp?.(duration);
}
__name(updateMeasure, "updateMeasure");
function childMetrics(root, path) {
  if (typeof path === "string") {
    return getChildMetric(root, path);
  }
  let oop = root;
  for (const p of path) {
    oop = getChildMetric(oop, p);
  }
  return oop;
}
__name(childMetrics, "childMetrics");
function getChildMetric(root, name) {
  let result = ownValue(root.measurements, name);
  if (result === void 0) {
    result = newMetrics();
    setOwnValue(root.measurements, name, result);
  }
  return result;
}
__name(getChildMetric, "getChildMetric");
function metricsAggregate(m, limit = -1, roundMath = false) {
  const entries = aggregateMetrics(m.measurements, limit);
  for (const group of Object.values(m.params)) {
    for (const param of Object.values(group)) {
      param.topResult?.sort((a, b) => b.value - a.value);
    }
  }
  const me = entries;
  const sumVal = (me.length === 0 ? m.value : 0) + me.filter((it) => !it[0].startsWith("#")).map((it) => it[1]).reduce((p, v) => {
    return p + v.value;
  }, 0);
  const ms = {};
  for (const [k, v] of limit === -1 ? entries : entries.slice(0, Math.max(0, limit))) {
    setOwnValue(ms, k, v);
  }
  return {
    operations: m.operations,
    measurements: ms,
    params: m.params,
    value: sumVal,
    topResult: m.topResult,
    namedParams: m.namedParams,
    opLog: m.opLog
  };
}
__name(metricsAggregate, "metricsAggregate");
function aggregateMetrics(m, limit = -1) {
  return Object.entries(m).map(([k, v]) => [k, metricsAggregate(v, limit)]).sort((a, b) => b[1].value - a[1].value);
}
__name(aggregateMetrics, "aggregateMetrics");
function sortedMeasurements(m) {
  return Object.entries(m).sort((a, b) => b[1].value - a[1].value);
}
__name(sortedMeasurements, "sortedMeasurements");
function toLen(val, sep, len) {
  while (val.length < len) {
    val += sep;
  }
  return val;
}
__name(toLen, "toLen");
function printMetricsChildren(params, offset, length) {
  let r = "";
  if (Object.keys(params).length > 0) {
    r += "\n" + toLen("", " ", offset);
    r += sortedMeasurements(params).filter((it) => it[1].value > 0.1).map(([k, vv]) => toString(k, vv, offset, length)).join("\n" + toLen("", " ", offset));
  }
  return r;
}
__name(printMetricsChildren, "printMetricsChildren");
function round2(value) {
  return Math.round(value * 100) / 100;
}
__name(round2, "round2");
function avg2(value, count) {
  return round2(value / (count > 0 ? count : 1));
}
__name(avg2, "avg2");
function printMetricsParams(params, offset, length) {
  let r = "";
  const joinP = /* @__PURE__ */ __name((key, data) => {
    return Object.entries(data).filter((it) => it[1].value >= 0.1).map(
      ([k, vv]) => `${toLen("", " ", offset)}${toLen(key + "=" + k, "-", length - offset)}: avg ${avg2(
        vv.value,
        vv.operations
      )} total: ${round2(vv.value)} ops: ${vv.operations}`.trim()
    );
  }, "joinP");
  const joinParams = Object.entries(params).flatMap(([key, values]) => joinP(key, values));
  if (joinParams.length > 0) {
    r += "\n" + toLen("", " ", offset);
    r += joinParams.join("\n" + toLen("", " ", offset));
  }
  return r;
}
__name(printMetricsParams, "printMetricsParams");
function toString(name, m, offset, length) {
  let r = `${toLen("", " ", offset)}${toLen(name, "-", length - offset)}: avg ${avg2(
    m.value,
    m.operations
  )} total: ${round2(m.value)} ops: ${m.operations}`.trim();
  r += printMetricsParams(m.params, offset + 4, length);
  r += printMetricsChildren(m.measurements, offset + 4, length);
  return r;
}
__name(toString, "toString");
function toJson(m) {
  const obj = {
    $total: m.value,
    $ops: m.operations
  };
  if (m.operations > 1) {
    obj.avg = avg2(m.value, m.operations);
  }
  if (Object.keys(m.params).length > 0) {
    obj.params = m.params;
  }
  for (const [k, v] of sortedMeasurements(m.measurements ?? {})) {
    obj[`${k} ${v.value} ${v.operations} ${v.operations > 1 ? avg2(v.value, v.operations) : ""}`] = toJson(v);
  }
  return obj;
}
__name(toJson, "toJson");
function metricsToString(metrics, name = "System", length) {
  return toString(name, metricsAggregate(metrics, 50, true), 0, length);
}
__name(metricsToString, "metricsToString");
function metricsToJson(metrics) {
  return toJson(metricsAggregate(metrics));
}
__name(metricsToJson, "metricsToJson");
function printMetricsParamsRows(params, offset) {
  const r = [];
  function joinP(key, data) {
    return Object.entries(data).map(([k, vv]) => [
      offset,
      `${key}=${k}`,
      avg2(vv.value, vv.operations),
      round2(vv.value),
      vv.operations
    ]);
  }
  __name(joinP, "joinP");
  for (const [k, v] of Object.entries(params)) {
    r.push(...joinP(k, v));
  }
  return r;
}
__name(printMetricsParamsRows, "printMetricsParamsRows");
function printMetricsChildrenRows(params, offset) {
  const r = [];
  if (Object.keys(params).length > 0) {
    sortedMeasurements(params).forEach(([k, vv]) => r.push(...toStringRows(k, vv, offset)));
  }
  return r;
}
__name(printMetricsChildrenRows, "printMetricsChildrenRows");
function toStringRows(name, m, offset) {
  const r = [[offset, name, avg2(m.value, m.operations), round2(m.value), m.operations]];
  r.push(...printMetricsParamsRows(m.params, offset + 1));
  r.push(...printMetricsChildrenRows(m.measurements, offset + 1));
  return r;
}
__name(toStringRows, "toStringRows");
function metricsToRows(metrics, name = "System") {
  return toStringRows(name, metricsAggregate(metrics, 50, true), 0);
}
__name(metricsToRows, "metricsToRows");
//# sourceMappingURL=metrics.js.map
